import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { adminSessionQueryOptions } from '@/lib/query-options'

// Every step of the MFA challenge requires a pending challenge (established by
// the login response and re-read from the session cookie on reload); without
// one the whole subtree falls back to login. Screens re-read the challenge
// (token + available methods) from the session query cache.
export const Route = createFileRoute('/(auth)/two-factor')({
	validateSearch: z.object({
		redirect: z.string().startsWith('/').optional()
	}),
	beforeLoad: async ({ context, search }) => {
		const session = await context.queryClient.fetchQuery(
			adminSessionQueryOptions()
		)
		if (session.sessionType !== 'mfa_pending') {
			throw redirect({
				to: '/login',
				search: { redirect: search.redirect }
			})
		}
	}
})
